import { Image } from "./Image";

export enum UserTypes {
  USER = "user",
  AMEEGO = "ameego",
  SERVICE_PROVIDER = "service_provider",
  ADMIN = "admin",
}

export type User = {
  id: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  profile_image?: Image;
  email_verified_at?: string;
  disabled: boolean;
  nationality?: string;
  created_at: string;
  updated_at?: string;
  has_ameego_profile: boolean;
  stripe_onboarded?: boolean;
  stripe_account_id?: string;
  stripe_onboarding_status?: string;
};

export type PaginatedUserList = {
  current_page: number;
  data: User[];
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
};

export type UnreadMessageRooms = {
  contexts: {
    [context: number]: {
      room_id: number;
      unread_count: number;
    }[];
  };
};

export type UnreadTripNotifications = {
  contexts: {
    [context: number]: {
      trip_id: number;
      unread_count: number;
    }[];
  };
};

export type SidebarContact = User & {
  friendship: {
    chat_room_id: number;
  };
};

export enum OnboardedStatus {
  "notStarted",
  "pending",
  "complete",
}

export enum AmeegoProfileStatus {
  "empty",
  "incomplete",
  "complete",
}
